module.exports = __webpack_public_path__ + "static/img/联想ThinkBook Plus 卷轴屏笔记本电脑.06621973.png";